import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { redirectIfNoAccessToWarehouseSync } from 'cio/utils/route-access';
import { getWarehouseDestinationName, WarehouseDestination } from 'cio/utils/warehouse';

export type IntegrationsWarehouseTypeRouteParams = { type: WarehouseDestination };

export default class IntegrationsWarehouseRoute extends Route {
  crumb() {
    let params = this.paramsFor(this.routeName) as IntegrationsWarehouseTypeRouteParams;

    return {
      name: getWarehouseDestinationName(params.type),
      path: 'integrations.warehouse.type',
      helpLabel: 'syncing to a warehouse',
      helpUrl: 'https://customer.io/docs/data-warehouse-sync',
    };
  }

  model(params: IntegrationsWarehouseTypeRouteParams) {
    return {
      type: params.type,
      sync: this.modelFor('integrations.warehouse'),
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoAccessToWarehouseSync(this, transition);
  }
}
